<script>
import { mapGetters } from 'vuex'
export default
{
    name: 'mv-user-form',

    computed:
    {
        ...mapGetters({
            locales: 'generalLocales',
            roles: 'generalRoles',
        })
    },

    methods:
    {
        save()
        {
            this.$emit('save')
        },

        submit()
        {
            this.$refs.form.submit()
        },
    },

    props:
    {
        model: Object,
        edit: Boolean,
    }

}
</script>

<template>
<div class="container">
    <form @submit.prevent.stop="save" ref="form">
        <div class="form-group">
            <label for="name" class="col-md-4 control-label">
                {{ $t('USER.EMAIL') }}
            </label>
            <div class="col-md-6">
                <input type="email" class="form-control" v-model="model.email" required>
            </div>
        </div>

        <div class="form-group">
            <label for="name" class="col-md-4 control-label">
                {{ $t('USER.NAME') }}
            </label>
            <div class="col-md-6">
                <input type="text" class="form-control" name="name" v-model="model.name" required>
            </div>
        </div>

        <div class="form-group">
            <label for="first_name" class="col-md-4 control-label">
                {{ $t('USER.FIRST_NAME') }}
            </label>
            <div class="col-md-6">
                <input type="text" class="form-control" name="first_name" v-model="model.first_name">
            </div>
        </div>

        <div class="form-group">
            <label for="last_name" class="col-md-4 control-label">
                {{ $t('USER.LAST_NAME') }}
            </label>
            <div class="col-md-6">
                <input type="text" class="form-control" name="last_name" v-model="model.last_name">
            </div>
        </div>

        <div class="form-group">
            <label for="country" class="col-md-4 control-label">
                {{ $t('USER.COUNTRY') }}
            </label>
            <div class="col-md-6">
                <input type="text" class="form-control" name="country" v-model="model.country">
            </div>
        </div>

        <div class="form-group">
            <label for="birthday" class="col-md-4 control-label">
                {{ $t('USER.BIRTHDAY') }}
            </label>
            <div class="col-md-6">
                <mv-date-time-picker only-date name="birthday" v-model="model.birthday" />
            </div>
        </div>

        <div class="form-group">
            <label for="name" class="col-md-4 control-label">
                {{ $t('USER.PASSWORD') }}
            </label>
            <div class="col-md-6">
                <input type="password" class="form-control" name="password" v-model="model.password" required>
            </div>
        </div>

        <div class="form-group">
            <label for="name" class="col-md-4 control-label">
                {{ $t('USER.LANGUAGE') }}
            </label>
            <div class="col-md-6">
                <select name="locale" v-model="model.locale" class="form-control">
                    <option v-for="locale in locales" :key="locale.id" :value="locale.id">{{ locale.name }}</option>
                </select>
            </div>
        </div>

        <div class="form-group">
            <label for="name" class="col-md-4 control-label">
                {{ $t('USER.ROLE') }}
            </label>
            <div class="col-md-6">
                <select name="locale" v-model="model.role_id" class="form-control" required>
                    <option v-for="role in roles" :key="role.id" :value="role.id">{{ role.name }}</option>
                </select>
            </div>
        </div>

        <div class="form-group">
            <label for="name" class="col-md-4 control-label">
                {{ $t('USER.MISC') }}
            </label>
            <div class="col-md-6">
                <textarea class="form-control" name="misc" v-model="model.misc" />
            </div>
        </div>

        <div class="form-group">
            <label for="name" class="col-md-4 control-label">
                {{ $t('USER.ALLOW_NOTIFICATIONS') }}
            </label>
            <div class="col-md-6">
                <input type="checkbox" name="allow_notifications" v-model="model.allow_notifications">
            </div>
        </div>

    </form>
</div>
</template>


// WEBPACK FOOTER //
// src/components/forms/UserForm.vue